import { render } from "./user.vue?vue&type=template&id=6f3a0a46&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&id=6f3a0a46&scoped=true&lang=css"
import "./user.vue?vue&type=style&index=1&id=6f3a0a46&lang=css"
script.render = render
script.__scopeId = "data-v-6f3a0a46"

export default script